import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PenFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M18.6618 3.761C17.9805 3.07967 16.8758 3.07967 16.1945 3.761L14.0081 5.94735L18.0528 9.99201L20.2391 7.80566C20.9205 7.12433 20.9204 6.01966 20.2391 5.33833L18.6618 3.761Z"
				fill="currentColor"
			/>
			<path
				d="M16.992 11.0527L12.9473 7.00801L4.85398 15.1014C4.50291 15.4524 4.25385 15.8923 4.13344 16.374L3.27241 19.8181C3.20851 20.0737 3.2834 20.344 3.46969 20.5303C3.65597 20.7166 3.92634 20.7915 4.18192 20.7276L7.62602 19.8666C8.10769 19.7462 8.54757 19.4971 8.89864 19.146L16.992 11.0527Z"
				fill="currentColor"
			/>
		</svg>
	);
}

PenFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PenFilledIcon;
